import cn from 'classnames';
import moment from 'moment';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import { changeShipmentPosting } from '../../../../actions/postings';
import PostingsApi from '../../../../API/shipment/postings-api';
import barcode_image from '../../../../assets/media/barcode-scan.png';
import default_image from '../../../../assets/media/icons/products.png';
import { Column, Row } from '../../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../../components/Basic/Buttons';
import { Icon, NavLink } from '../../../../components/Basic/Elements';
import { DateInput, Select } from '../../../../components/Basic/Inputs';
import { TableCell, TableLine } from '../../../../components/Basic/Table';
import { TextGrey, Tooltip } from '../../../../components/Basic/WrapsStyle';
import PostingStatusWrap from '../../../../components/Shipments/WrapStyle/PostingStatus';
import { DIFF_STATUSES, MAP_SKLAD_SHORT, MAP_SKLAD_SHORT_ANOTHER, TO_POSING, TO_SHIPMENT, TYPE_BUTTONS } from '../../../../constans';
import { formFullDate, getDateMonth, getDateSolid } from '../../../../utils';
import IncreasedCommissionTimerBlock from '../../../Orders/Wb/Orders/IncreasedCommissionTimerBlock';
import CommentPostingProductBlock from '../../Posting/CommentBlock';
import { WIDTH_POSTING } from '../index';
import RebuyPopUp from '../RebuyPopUp';
import styles from './styles.module.scss';

const STATE = {
  not_collected: { text: 'Не обработан', color: '' },
  not_started: { text: 'Не собран', color: '' },
  started: { text: 'Комплектуется', color: 'rgb(255 112 0 / 18%)' },
  collected: { text: 'Ожидает упаковки', color: 'rgb(88 143 255 / 37%)' },
  packed: { text: 'Упакован', color: 'rgb(69 255 156 / 51%)' },
  printed: { text: 'Упакован', color: '#39ee3f47' },
};

const PostingLine = ({
  productAltMap,
  MODES,
  shipmentMode = true,
  order = {},
  shipment = {},
  map = {},
  postingsPrint = {},
  changePostingPrint = (_) => _,
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  productsMap = productsMap,
  PROVIDERS_NAMES,
  providers,
  isAdmin = false,

  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [showModalRebuy, setShowModalRebuy] = useState({ state: false, product: {} });


  const [images, setImages] = useState([]);

  const dispatch = useDispatch();

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const changeData = async (productId, key, value) => {
    await PostingsApi.changeProductInPosting({ data: { postingNumber: order.posting_number, productId, field: key, value } }).then((r) => {
      dispatch(changeShipmentPosting(r.posting));
    });
  };

  const changePosting = async ({ postingNumber, field, value }) => {
    await PostingsApi.changePosting({ data: { postingNumber, field, value } }).then((r) => {
      dispatch(changeShipmentPosting(r.posting));
    });
  };

  return (
    <>
      <TableLine
        style={order.is_printed /*&& shipmentMode === MODES[0] */ ? { background: STATE['printed'].color } : {}}
        key={order.posting_number}
      >
        {order.is_printed && <div className={styles.status_line} />}
        {shipmentMode === MODES[0] && (
          <>
            <TableCell width={WIDTH_POSTING[8]} minWidth={WIDTH_POSTING[8]} center={true}>
              <Button type={TYPE_BUTTONS.WHITE} className={styles.white_button} onClick={() => printSticker(order)}>
                <Icon src={barcode_image} width="35px" />
              </Button>
              <CheckButton
                checked={order.is_printed}
                small
                style={{ marginLeft: '10px' }}
                onSelect={() => changePrintStatus([order.posting_number], !order.is_printed)}
              />
            </TableCell>
            <TableCell width={WIDTH_POSTING[0]} minWidth={WIDTH_POSTING[0]}>
              {isAdmin ? (
                <Link to={TO_POSING(order.posting_number)} className={styles.link} target="_blank">
                  {order.posting_number}
                </Link>
              ) : (
                <>{order.posting_number} </>
              )}{' '}
              {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
              <Row style={{ width: '100%' }}>
                {order.market === 'wb' && (
                  <TextGrey style={{ fontSize: '18px', color: '#6c11c9' }}>{order.shop}</TextGrey>
                )}
                {order.market === 'yandex' && (
                  <TextGrey style={{ fontSize: '18px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
                )}
                {order.market === 'ozon' && (
                  <TextGrey style={{ fontSize: '18px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
                )}
                {order.market === 'sber' && (
                  <TextGrey style={{ fontSize: '18px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
                )}
              </Row>
            </TableCell>
            <TableCell width={WIDTH_POSTING[12]} minWidth={WIDTH_POSTING[12]} center>
              <NavLink
                to={TO_SHIPMENT(order.shipment_id)}
                target={'_blank'}
                className={styles.scan_time}
                style={{ fontSize: '18px' }}
              >
                {getDateMonth(order.dates.shipment_date)}
              </NavLink>
            </TableCell>
          </>
        )}
        {shipmentMode === MODES[1] && (
          <>
            <TableCell width={WIDTH_POSTING[0]} minWidth={WIDTH_POSTING[0]}>
              <Row>
                <NavLink
                  to={TO_SHIPMENT(order.shipment_id)}
                  target={'_blank'}
                  className={styles.scan_time}
                  style={{ fontSize: '18px' }}
                >
                  {getDateMonth(order.dates.shipment_date)}
                </NavLink>

                <Row style={{ width: '100%' }}>
                  {order.market === 'wb' && (
                    <TextGrey style={{ fontSize: '18px', color: '#6c11c9' }}>{order.shop}</TextGrey>
                  )}
                  {order.market === 'yandex' && (
                    <TextGrey style={{ fontSize: '18px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
                  )}
                  {order.market === 'ozon' && (
                    <TextGrey style={{ fontSize: '18px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
                  )}
                  {order.market === 'sber' && (
                    <TextGrey style={{ fontSize: '18px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
                  )}
                </Row>
              </Row>
            </TableCell>
          </>
        )}
        <TableCell width={WIDTH_POSTING[1]} minWidth={WIDTH_POSTING[1]} style={{ padding: '5px 2px' }}>
          <Column>
            {order.products.map((p, k) => {
              const data = map[p.offer_id] || {};
              const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
              const scan_time = p.scan_time ? formFullDate(p.scan_time) : null;
              return (
                <div key={k} className={styles.div_line_images}>
                  <div className={styles.wrapper}>
                    <img
                      onClick={() => openImageViewer(img)}
                      className={styles.preview}
                      src={img.length > 0 ? img[0] : undefined}
                    />
                  </div>
                  <Column>
                    <div className={styles.name}>
                      {`${p.ordered_quantity} x ${p.name}  `}
                      <div className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                        {p.offer_id}
                      </div>
                    </div>
                    {scan_time && (
                      <div className={styles.scan_time}>
                        {scan_time} {p.scan_user && `(${p.scan_user})`}
                      </div>
                    )}
                  </Column>
                </div>
              );
            })}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[8]} minWidth={WIDTH_POSTING[8]} center={true}>
          <Column center>
            {order.products.map((p, k) => (
              // eslint-disable-next-line react/no-array-index-key
              <Row key={k} className={styles.div_line}>
                <div className={styles.num}>{p.common_quantity || 0}</div>
              </Row>
            ))}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[15]} minWidth={WIDTH_POSTING[15]} center={true}>
          <PostingStatusWrap order={order}>
            {order.status === 'Ожидает отгрузки' && order.market === 'wb' && (
              <IncreasedCommissionTimerBlock date={order.dates.created_at} only_hours={true} />
            )}
          </PostingStatusWrap>
        </TableCell>
        <TableCell width={WIDTH_POSTING[14]} minWidth={WIDTH_POSTING[14]} center={true}>
          <Column>
            {order.products.map((p, k) => (
              // eslint-disable-next-line react/no-array-index-key
              <Row key={`${order.posting_number}-${p.offer_id}-19`} className={styles.div_line} center={true}>
                {(p['diff'].comment || '').length > 0 ? (
                  <>
                    <Tooltip text={p['diff'].comment}>
                      {p.diff.status} {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`} *
                    </Tooltip>
                  </>
                ) : (
                  <>
                    {p['diff'].status} {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`}
                  </>
                )}
              </Row>
            ))}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[8]} minWidth={WIDTH_POSTING[8]} center={true}>
          {/* <div>{MAP_SKLAD_SHORT[order.sklad]}</div> */}
          <Column>
            <div className={styles.div_line}>
              <Select
                select={MAP_SKLAD_SHORT[order.sklad]}
                list={['Мск', 'Екб']}
                style={{ fontSize: '14px' }}
                width={'75px'}
                changeDifernceStatus
                disabled={order.market !== 'wb'}
                onSelect={(v) => { console.log(v); changePosting({ postingNumber: order.posting_number, field: 'skladName', value: MAP_SKLAD_SHORT_ANOTHER[v] }) }}
                {...props}
              />
            </div>
          </Column>
        </TableCell>
        {shipmentMode !== MODES[0] && (
          <>


            <TableCell width={WIDTH_POSTING[14]} minWidth={WIDTH_POSTING[14]} center={true}>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={k} className={styles.div_line_column} style={{ fontSize: '15px', fontWeight: '600' }}>
                    <div
                      style={{ color: (productsMap[p.provider_sku] || {}).stocks?.[order.sklad] > 0 ? 'green' : 'red' }}
                    >
                      {(map[p.offer_id] || {}).provider_artnumber}
                    </div>
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[17]} center={true}>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  <div key={k} className={styles.div_line_column} style={{ fontSize: '15px', fontWeight: '600' }}>
                    <Column center={true}>
                      <div>{p.price}</div>
                      <div style={{ color: '#3c3c3ca0' }}>{+(p.commission?.common?.rub)?.toFixed(0)}</div>
                    </Column>
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={'100px'} center={true}>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={k} className={styles.div_line_column} style={{ fontSize: '15px', fontWeight: '600' }}>
                    {(productsMap[p.provider_sku] || {}).stocks?.[order.sklad === 'msk' ? 'ekb' : 'msk'] > 0 ?
                      <div style={{ padding: '6px 10px', margin: '0 10px 6px 0', fontWeight: 'bold', borderRadius: '100px', ...(order.market === 'wb' ? { backgroundColor: '#2af32da3' } : { backgroundColor: '#536f5343' }) }}>+</div>
                      :
                      <div style={{ padding: '6px 10px', margin: '0 10px 6px 0' }}></div>
                    }
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={'100px'} center={true}>
              <Column style={{ alignItems: 'center' }}>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={k} className={styles.div_line_column} style={{ cursor: 'pointer', fontSize: '15px', fontWeight: '600' }}>
                    {productAltMap[p.provider_sku]?.length > 0 ?
                      <div style={{ padding: '6px 10px', margin: '0 10px 6px 0', fontWeight: 'bold', borderRadius: '100px', backgroundColor: '#00b403f4' }}
                        onClick={() => {
                          setShowModalRebuy({ state: true, product: p })
                        }}
                      >+</div>
                      :
                      <div style={{ padding: '6px 10px', margin: '0 10px 6px 0' }}></div>
                    }
                  </div>
                ))}
              </Column>
            </TableCell>
            <TableCell width={WIDTH_POSTING[3]} minWidth={WIDTH_POSTING[3]}>
              <Column>
                {order.products.map((p, k) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <div key={k} className={styles.div_line}>
                    <Select
                      select={p.dokup.status}
                      list={['Заказан', 'Нет в наличии', 'Поменять пересорт', 'Нет']}
                      style={{ fontSize: '14px' }}
                      width={'160px'}
                      changeDifernceStatus
                      onSelect={(v) => changeData(p._id, 'dokup_status', v === 'Нет' ? null : v)}
                      {...props}
                    />
                  </div>
                ))}
              </Column>
            </TableCell>
          </>
        )}

        <TableCell width={WIDTH_POSTING[4]} minWidth={WIDTH_POSTING[4]}>
          <Column>
            {order.products.map((p, k) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={k} className={styles.div_line}>
                <Select
                  select={p.dokup.provider_name}
                  list={['Перекуп', ...PROVIDERS_NAMES, 'Магазин']}
                  style={{ fontSize: '16px' }}
                  width={'150px'}
                  changeDifernceStatus
                  onSelect={(v) => changeData(p._id, 'dokup_provider', v)}
                  {...props}
                />
              </div>
            ))}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[13]} minWidth={WIDTH_POSTING[13]}>
          <Column>
            {order.products.map((p, k) => {
              return (
                <div key={k} className={styles.div_line}>
                  <DateInput
                    className={styles.date_input}
                    classNameCalendar={styles.date_input_calendar}
                    value={p.dokup.date && getDateSolid(p.dokup.date)}
                    onChange={(v) => changeData(p._id, 'dokup_date', moment(v).utc(true))}
                  />
                </div>
              )
            })}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[11]} minWidth={WIDTH_POSTING[11]} center={true}>
          <Column>
            {order.products.map((p, k) => {
              const lastDiffDate = order.history.findLast(hel => hel.field === 'shipment_diff' && hel.offer_id === p.offer_id)?.date || null
              const lastDokupDate = p?.dokup?.date || null
              // console.log('lastDiffDate', lastDiffDate)
              // console.log('lastDokupDate', lastDokupDate)
              // eslint-disable-next-line react/no-array-index-key
              return (
                <div key={k} className={styles.div_line}>
                  <Select
                    select={p.shipment_diff === 'Нет' ? null : p.shipment_diff}
                    list={DIFF_STATUSES}
                    style={{ fontSize: '12px' }}
                    width={'175px'}
                    onSelect={(v) => changeData(p._id, 'shipment_diff', v === 'Нет' ? '' : v)}
                    {...props}
                  />
                  {/* {(lastDiffDate && lastDokupDate) && (new Date(lastDiffDate)?.getTime() < new Date(lastDokupDate)?.getTime()) ? 'Расхождение устарело' : 'Нет'} */}
                </div>
              )
            })}
          </Column>
        </TableCell>
        <TableCell width={WIDTH_POSTING[16]} minWidth={WIDTH_POSTING[16]}>
          <Column>
            {order.products.map((p, k) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={k} className={styles.div_line}>
                <CommentPostingProductBlock
                  posting={order}
                  offer_id={p.offer_id}
                  onChange={(v) => changeData(p._id, 'comment', v)}
                />
              </div>
            ))}
          </Column>
        </TableCell>

        {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
      </TableLine>
      {
        showModalRebuy.state && (
          <RebuyPopUp
            order={order}
            product={showModalRebuy.product}
            alts={productAltMap[showModalRebuy.product.provider_sku]}
            // onChangeOrderData={onChangeOrderData}
            // providers={[{ name: 'Другой', id: null }, ...providers]}
            providers={[{ name: 'Другой', id: null }, ...providers]}
            // doDelete={modalFunctionDelete}
            close={() => {
              setShowModalRebuy({ ...showModalRebuy, state: false });
            }}
          />
        )
      }
    </>
  );
};

export default PostingLine;
